<template>
  <div class="layout-wrapper">
    <login v-if="!isLogin"></login>
    <el-container v-else style="height: 100%">
      <!-- 头部 -->
      <el-header class="custom-header">
        <Header :saveAdminRoleInfoKey="'saveUserInfoStorage'" :adminInfoKey="'AdminInfo'" :adminCacheKey="'AdminCache'" projectApiPrefix="/api2" loginApiPrefix="/api1" gatewayApiPrefix="/api4"  :isCollapse="isCollapse"></Header>
      </el-header>
      <el-container>
        <!-- 左侧菜单 -->
        <side-bar
          ref="sidebarRef"
          @add-tab="addTab"
          @default-Page="getDefaultPage"
          @change-collapse="changeCollapse"
          :ready="sidebarReady"
          :saveAdminRoleInfoKey="'saveUserInfoStorage'"
          :adminInfoKey="'AdminInfo'"
          :adminCacheKey="'AdminCache'" projectApiPrefix="/api2" loginApiPrefix="/api1" gatewayApiPrefix="/api4"
        ></side-bar>
        <!-- 中间内容 -->
        <el-main>
          <el-tabs
            @tab-click="handleTabClick"
            v-model="editableTabsValue"
            type="card"
            class="custom-tabs"
            closable
            @tab-remove="removeTab"
          >
            <el-tab-pane
              class="custom-tab-pane"
              v-for="item in editableTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            >
              <component
                :is="item.component"
                :tableMaxHeight="tableMaxHeight"
                ref="cleanRef"
                :iSclean="iSclean"
                :editId="editId"
                @add-tab="addTab"
                @removeTab2="removeTab2"
                @updateTab="updateTab"
              ></component>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Login from "views/Login";
import { reactive, toRefs, computed, toRaw,ref,onMounted,nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
import {loginRoleInformationV2} from 'network/projectLogin'
import {GetAdminLoginToken,loginRoleInformation,saveloginInfo} from 'network/login.js'
import { defaultColor, defaultThemeStyle } from "common/const";
import { setThemeColor } from "common/setThemeColor";
// 使用公共组件库（支持远程/本地切换）
import { Header, SideBar } from 'common/shared-components.js';
export default {
  name: "Index",
  components: {
    Header,
    SideBar,
    Login,
  },

  setup() {
    const store = useStore();
    const cleanRef = ref();
    // 在 setup 阶段判断是否有 key 参数
    // 如果没有 key，立即允许 SideBar 初始化（在 onMounted 时执行）
    // 如果有 key，需要等待 GetAdminLoginTokenData 完成后再初始化
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const hasKey = params.get("key");
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isCollapse: false, //切换菜单折叠
      editableTabsValue: "2", //指定当前选中的标签页
      editableTabs: [], //标签页
      iSclean:false,
      editId:0,
      comps: [],
      sidebarReady: !hasKey, // 如果没有 key，立即允许 SideBar 在 onMounted 时初始化
      // 表的最大高度:动态计算
      tableMaxHeight: computed(() => {
        const h =
          document.documentElement.clientHeight || document.body.clientHeight;
        return h - 220;
      }),
      // 登录状态
      isLogin: computed(() => {
        return store.state.isLogin || sessionStorage.getItem("isLogin");
      }),
    });
    onMounted(async () => {
        // 如果有 key 参数，需要等待 GetAdminLoginTokenData 完成后再初始化 SideBar
        if(hasKey){
              const tokenKey = params.get("key");
              sessionStorage.clear();
            
             await GetAdminLoginTokenData(tokenKey)
              // 删除地址栏参数
              const cleanUrl = window.location.origin + window.location.pathname;
              window.history.replaceState({}, document.title, cleanUrl);
              data.sidebarReady = true;
        }else{
          const storedToken = sessionStorage.getItem("token");
          if (storedToken) {
              getLoginRoleInfo();
          }
        }
    });
    //根据key获取token
    const GetAdminLoginTokenData=async(key)=>{ 
      const res = await GetAdminLoginToken({key:key});
      if(res.data.code==1){
          const tokenData = res.data.result;
          let expiresTime = tokenData.expires_in + new Date() / 1000;
          const token = {
            AccessToken: tokenData.access_token,
            AccessExpiresIn: expiresTime,
            RefreshToken: tokenData.refresh_token,
          };
          store.commit("saveTokenStorage", token);
          // 将token存储到sessionStorage
          sessionStorage.setItem('token', JSON.stringify(token));
          await getInfo(token);
          // 获取管理员角色信息-升本中心管理员信息
          await getLoginRoleInfo(token);
          
      }
    }; 
      const getLoginRoleInfo =async (token)=>{
        const result = await loginRoleInformationV2();
        if(result.code==1){
          const AdminRoleInfo = result.result;
          sessionStorage.setItem("AdminCache", JSON.stringify(AdminRoleInfo)); //存储AdminRoleInfo
          if(token){
            saveloginInfo(token, AdminRoleInfo);  
          }
          // store.commit("saveAdminRoleInfo", AdminRoleInfo); //同时更新store中的AdminRoleInfo                       // 存储主题色
          let style;
          if (result.result && result.result.webStyle) {
            style = JSON.parse(result.result.webStyle);
          } else {
            style = defaultThemeStyle;
          }
          document.title = result.result?.nameAll || "湖北专升本网";
          store.commit("changeThemeColor", JSON.stringify(style));
          setColor(style);
        }
      }
    // 获取默认页面参数
    const getDefaultPage = (val) => {
      // console.log(val, "获取默认页面参数");
      if (val) {
        if (JSON.stringify(data.comps) == "[]") {
          data.comps.push(val);
          defaultComponent();
        } else {
          data.comps.map((item) => {
            if (item.title != val.title) {
              data.comps.push(val);
              defaultComponent();
            }
          });
        }
      } else {
        ElMessage.warning("未设置默认菜单");
      }
    };
    // 默认展示页面
    function defaultComponent() {
      data.comps.map((item) => {
        data.editableTabs.push({
          title: item.title,
          name: item.name,
          content: item.title,
          component: require(`./tabpane/${item.component}.vue`).default,
        });
        data.editableTabsValue = item.name;
      });
    }
    // 点击左侧菜单打开窗口
    const addTab = (targetObj) => {
     
      data.editableTabsValue = targetObj.index; //渲染标签页
      const newTabName = targetObj.component;
      const tab = JSON.parse(JSON.stringify(data.editableTabs));
      // 同一个窗口不能重复打开 查找是否存在
      const oldtab = tab.find((tab) => tab.component.name === newTabName);
      if (oldtab) {
        ElMessage("当前窗口已打开");
        return false;
      } else {
        if(targetObj.id){
          data.editId = targetObj.id
        }else{
          data.editId = 0
        }
        // 新增窗口
        data.editableTabs.push({
          title: targetObj.title,
          name: targetObj.index,
          content: targetObj.title,
          index:targetObj.index,
          component: require(`./tabpane/${targetObj.component}.vue`).default,
          // component的值必须与对应的vue文件名保持一致
          // require最常用的方法
          // require(‘http’) 内置模块
          // require(‘./server’) “./”表示当前路径，后面跟的是相对路径
          // require(“…/lib/server”) …/表示上一级目录，后面跟的也是相对路径
        });
      }
    };
   
    const clean = (type)=>{
      cleanRef.value.forEach((item,i)=>{
        try {
          if(type == 1){
            if(item.resetForm1()){
              cleanRef.value.resetForm1()
            }
          }else{
            if(item.resetForm()){
              cleanRef.value.resetForm()
            }
          }
        } catch(err) {
          
        }
      })
  
    };
    
    // 移除窗口
     const removeTab =async (targetName) => {
      let tabs = data.editableTabs;
      if (tabs.length === 1) {
        ElMessage({
          message: "至少保留一个窗口！",
        });
        return false;
      }
      
      if(targetName == 24){
        await clean()
      }else if(targetName == 25){
        await clean(1)
      }
      
      let activeName = data.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
              sidebarRef.value.setActive(nextTab.index)
            }
          }
        });
      }
      data.editableTabsValue = activeName;
      data.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    };
    const sidebarRef = ref(null);
    // 处理标签页点击
    const handleTabClick = (tab) => {
      // 找到对应的标签页
      const clickedTab = data.editableTabs.find(item => item.index === tab.props.name);
      console.log("handleTabClick", tab, clickedTab);
      if (clickedTab) {
        // 更新sessionStorage和Vuex中的tabObj
        sessionStorage.setItem("tabObjDown", JSON.stringify(clickedTab));
        sessionStorage.setItem("tabObj", JSON.stringify(clickedTab));
        sidebarRef.value.setActive(clickedTab.index)
      }
    };
    const removeTab2 =async (targetName) => {
      let tabs = data.editableTabs;
      if (tabs.length === 1) {
        ElMessage({
          message: "至少保留一个窗口！",
        });
        return false;
      }
      
      let activeName = data.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      data.editableTabsValue = activeName;
      data.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    };
    // 更新列表
    const updateTab=(targetName)=>{
      const indexNow = (data.editableTabs || []).findIndex(
          (item) => item.name == targetName
        );
        // 如果是文章列表页面则刷新，添加文章后刷新列表用
        if (
          cleanRef.value[indexNow] &&
          cleanRef.value[indexNow] != undefined
        ) {
          cleanRef.value[indexNow].updateList();
        }
    };
    const changeCollapse = (bol) => {
      data.isCollapse = bol;
    };
    const getInfo = (token) => {
      let AdminInfo;
      loginRoleInformation().then((result1) => {
        if (result1.code != 0) {
          // 登录成功提示
          ElMessage({ message: "登录成功！", type: "success" });
          AdminInfo = result1.result;
          sessionStorage.setItem("AdminInfo", JSON.stringify(AdminInfo)); //存储AdminInfo
          store.commit("saveAdminInfo", AdminInfo); //同时更新store中的AdminInfo
          let isDelect = false;
          if (
            result1.result.roleId == result1.result.adminRoleId ||
            result1.result.roleId == result1.result.engineerRoleId
          ) {
            isDelect = true;
          } else {
            isDelect = false;
          }
          sessionStorage.setItem("isDelect", JSON.stringify(isDelect));
        } else {
          AdminCache = false;
          ElMessageBox.alert(result1.message, {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        }
      });
    };
    const setColor = (style) => {
      
      nextTick(() => {
        setThemeColor(style.ThemeColor);
        document.querySelector("body").setAttribute(
          "style",
          `
            --themeColor: ${style.ThemeColor || "#409EFF"};
            --SliderMenuColor: ${style.SliderMenuColor || "#eef1f6"};
            --MenuFontColor: ${style.MenuFontColor || "#333333"};
            --UnderlineColor: ${style.UnderlineColor || "#48494b"};
            --HeadBgColor: ${style.HeadBgColor || "#fd5252"};
            --HeadTextColor: ${style.HeadTextColor || "#FFFFFF"};
            --Success: ${style.Success || "#67C23A"};
            --Warning: ${style.Warning || "#E6A23C"};
            --Danger: ${style.Danger || "#F56C6C"};
            --Info: ${style.Info || "#909399"};
        `
        );
      });
      store.commit("changeThemeColor", JSON.stringify(style));
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getDefaultPage,
      addTab,
      removeTab,
      removeTab2,
      changeCollapse,
      cleanRef,
      clean,
      updateTab,
      handleTabClick,
      sidebarRef
    };
  },
};
</script>
<style scoped>
  .layout-wrapper {
    width: 100%;
    height: 100%;
    min-width: 1560px;
  }

  .custom-header {
    padding: 0;
    height: 47px !important;
  }

  .el-main {
    padding: 1px 0 0 0;
    background-color: #edf4fc;
    /* height: calc(100% - 47px); */
    overflow: hidden;
    box-sizing: border-box;
  }

  .custom-tab-pane {
    background-color: #fff;
    border-top: none;
    padding: 12px 15px 0 15px;
    height: 100%;
    box-sizing: border-box;
  }

  .custom-tabs ::v-deep .el-tabs__header {
    border-bottom: 1px solid #e4e7ed;
    height: 42px;
    background: #ffffff;
    border-radius: 4px;
  }

  .custom-tabs ::v-deep .el-tabs__nav-wrap {
    height: 42px;
  }

  .custom-tabs ::v-deep .el-tabs__nav-scroll {
    height: 42px;
  }

  .custom-tabs ::v-deep .el-tabs__nav {
    height: 42px !important;
    line-height: 42px !important;
    display: flex;
    align-items: center;
    border: none !important;
    border-bottom: none;
    border-radius: 0 !important;
    box-sizing: border-box;
  }

  /* 每个小tab样式 高度 用来限制右侧竖线高度 */
  .custom-tabs ::v-deep .el-tabs__item {
    height: 20px;
    line-height: 20px;
    border-right: 1px solid #dde0e4;
    border-left: none;
  }

  /* 去掉小tab默认左侧竖线 */
  .custom-tabs ::v-deep .el-tabs__item {
    border-left: none !important;
  }

  /* 未选中tab */
  ::v-deep .el-tabs .el-tabs__item {
    color: #909399;
  }

  ::v-deep .el-tabs .el-tabs__item {
    background-color: #fff;
  }

  /* 选中tab */
  ::v-deep .el-tabs__item.is-active {
    color: #000;
  }
  .remarks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}
.icon-warning {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid;
  border-radius: 50%;
  font-size: 14px;
  text-align: center;
  line-height: 14px;
  margin-left: 4px;
}
.remarks-header-wrapper {
  margin-bottom: 5px;
}
.tips .header {
    position: relative;
    display: flex;
    align-items: center;
}

.tips .header .el-icon-close {
      position: absolute;
      top: 0;
      right: 0;
    }

.tips .content {
    max-width: 500px;
    min-width: 100px;
    white-space: wrap;
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.5;
  }

.tips .tipBtn {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    color: #4a7fe8;
    line-height: 50px;
  }
</style>

<style>
  .el-tabs {
    height: 100%;
  }

  .main_right {
    flex: 1;
    flex-basis: auto;
    overflow: auto;
    box-sizing: border-box;
  }

  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs .el-tabs__item {
    background-color: rgb(238, 241, 246);
  }

  .el-tabs .el-tabs__item.is-active {
    background-color: #fff;
  }

  .el-tabs__content {
    height: calc(100% - 42px);
    overflow: hidden;
    /* margin-left: 15px; */
    margin-right: 10px;
    border-radius: 4px;
    margin-top: 10px;
  }

  /* icon - x - font */
  .el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close {
    font-size: 14px;
  }
  
</style>
